import { CreditCard, Plus } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Stack } from '../../../../design-system/stack/stack';

type CardsEmptyStateProps = {
  onCreateCard: () => void;
};

/**
 * Empty state component displayed when user has no virtual cards.
 * Shows an icon, title, description and a call-to-action button to create the first card.
 *
 * @param props.onCreateCard - Callback fired when the "Create card" button is clicked
 *
 * @example
 * ```tsx
 * <CardsEmptyState onCreateCard={() => console.log('Create card clicked')} />
 * ```
 */
export const CardsEmptyState = ({ onCreateCard }: CardsEmptyStateProps) => {
  return (
    <div className="rounded-lg border border-border bg-card px-0 py-24">
      <Stack space={6} align="center" className="mx-auto max-w-[308px]">
        <Stack space={4} align="center">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
            <CreditCard size={24} strokeWidth={1.5} />
          </div>

          <Stack space={2} align="center">
            <h2 className="text-center text-lg leading-7 font-medium">Create your first card</h2>

            <p className="text-center text-sm leading-relaxed text-muted-foreground">
              Give your team spending power with instant virtual cards
            </p>
          </Stack>
        </Stack>

        <Button iconLeft={<Plus size={16} />} onClick={onCreateCard}>
          Create card
        </Button>
      </Stack>
    </div>
  );
};
